import state from './yearState'
import mutations from './yearMutations'
import getters from './yearGetters'
import actions from './yearActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
